export const LAST_USED_DC = 'lastUsedDataCenter';
